// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154iv47k{top:var(--ds-space-250,20px)}\n._18u01jfw{margin-left:var(--ds-space-500,40px)}\n._1ltv1ejb{left:var(--ds-space-300,24px)}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
